export const SET_METRICS = 'SET_METRICS'
export const SET_METRIC = 'SET_METRIC'
export const SET_METRIC_TYPES = 'SET_METRIC_TYPES'
export const SET_CHARTS = 'SET_CHARTS'
export const RESET_METRIC = 'RESET_METRIC'
export const RESET_METRICS = 'RESET_METRICS'
export const RESET_METRIC_TYPES = 'RESET_METRIC_TYPES'
export const RESET_CHARTS = 'RESET_CHARTS'
